<div class="table-responsive" *ngIf="tableData && tableCellAttributes">
  <table class="table" [ngClass]="customTableStyle">
    <colgroup *ngIf="tableCellStyles">
      <col
        *ngFor="let attribute of tableCellAttributes; index as i"
        [ngStyle]="{
          width: tableCellStyles.index[i] === i ? tableCellStyles.width[i] + 'px' : ''
        }"
      />
    </colgroup>
    <thead class="hide-element position-relative">
      <tr>
        <th
          *ngFor="let data of tableData.thead; index as i"
          scope="col"
          [attr.class]="'thead-col-' + i"
          [attr.data-test-id]="'thead-col-' + i"
        >
          <span [attr.data-test-id]="'thead-text-' + i">
            {{ data.text | translate }}
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let tableRowData of tableData.tbody; index as rowIndex" [attr.data-test-id]="'table-row-' + rowIndex">
        <td *ngFor="let tableCellAttribute of tableCellAttributes; index as cellIndex">
          <ng-container
            dynamicTable
            [tableCellAttribute]="tableCellAttribute"
            [tableRowData]="tableRowData"
            [rowIndex]="rowIndex"
            [cellIndex]="cellIndex"
            (action)="onAction($event)"
            [isExpired]="isExpired"
            [redirectToLoginIfNoSession]="redirectToLoginIfNoSession"
          ></ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>
